function Counter(container, options) {
	this.container = container;
	this.startTime = null;

	this.options = {
		'startInViewPort' : true
	};

	// merge input options whith default options
	for (var attrname in options) { this.options[attrname] = options[attrname]; }

	this.numberElements = [];

	this.updateAnimation = this.updateAnimation.bind(this);
	this.startAnimation = this.startAnimation.bind(this);

	// NOTE: cannot use foreach because babel + IE11
	for (let i=0;i<this.container.childNodes.length;i++) {
		if (this.container.childNodes[i].nodeType == 1) {
			this.numberElements.push(this.container.childNodes[i]);
		}
	}

	this.maxNumber = this.getCurrentNumber();

	if (!this.options.animationDuration) {
		this.options.animationDuration = (this.maxNumber * 0.3 < 1000 ? 1000 : this.maxNumber * 0.3);

		if (this.options.animationDuration > 5000) {
			this.options.animationDuration = 5000;
		}
	}

	this.resetDom();

	if (this.options.startInViewPort && typeof IntersectionObserver !== 'undefined') {
		this.observer = new IntersectionObserver(function(entries) {
			if (entries[0].intersectionRatio <= 0) return;

			setTimeout(this.startAnimation, 500);
		}.bind(this));
		this.observer.observe(this.container);
	}
	else {
		setTimeout(this.startAnimation, 1500);
	}
}

Counter.prototype.startAnimation = function() {
	if (this.startTime) {
		return;
	}

	this.startTime = new Date();
	this.updateAnimation();
};

Counter.prototype.updateAnimation = function() {
	let animationPercent = this.getTimePassedInPercent();

	const currentNumberInTime = this.maxNumber * (animationPercent / 100);

	const easeNumber = Math.round(this.easeOutQuad(currentNumberInTime, 0, this.maxNumber, this.maxNumber));

	this.updateDom(easeNumber);

	if (animationPercent < 100) {
		requestAnimationFrame(this.updateAnimation);
	}
	else {
		this.endAnimations();
	}
};

Counter.prototype.getCurrentNumber = function() {
	let totalNumber = '';
	this.numberElements.forEach(node => {
		let number = '';
		for (let i=0;i<node.childNodes.length;i++) {
			if (node.childNodes[i].nodeType === 3) {
				number += node.childNodes[i].nodeValue
			}
		}
		totalNumber += number;
	});

	return parseInt(totalNumber);
};

Counter.prototype.getTimePassedInPercent = function() {
	const currentTime = new Date();
	const timeDiff = currentTime - this.startTime;

	const percent = timeDiff / this.options.animationDuration * 100;

	return percent > 100 ? 100 : percent;
};

Counter.prototype.resetDom = function(number) {
	this.updateDom(0);
};

Counter.prototype.updateDom = function(number) {
	let numberAsString = number.toString();
	while (this.numberElements.length > numberAsString.length) {
		numberAsString = '0' + numberAsString;
	}

	for (let i=0;i<this.numberElements.length;i++) {
		while (this.numberElements[i].firstChild) {
			this.numberElements[i].removeChild(this.numberElements[i].firstChild);
		}

		this.numberElements[i].appendChild(document.createTextNode(numberAsString[i]));
	}
};

Counter.prototype.endAnimations = function() {
	if (this.observer ){
		this.observer.disconnect();
	}
};

Counter.prototype.easeOutQuad = function(t, b, c, d) {
	var ts =(t/=d)*t;
	var tc =ts*t;
	return b+c*(tc*ts + -5*ts*ts + 10*tc + -10*ts + 5*t);
};

export default Counter;